/* "Barrel" of Http Interceptors */
/* @see: https://angular.io/guide/http#intercepting-requests-and-responses */
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { HttpErrorInterceptor } from './error.interceptor';
import { HttpAuthInterceptor } from "./auth.interceptor";
import { HttpVersionInterceptor } from "./version.interceptor";
import { HttpXsrfInterceptor } from "./xsrf.interceptor";
import { Response503Interceptor } from "./response503.interceptor";

/** Http interceptor providers in outside-in order */
export const HttpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: HttpAuthInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: HttpVersionInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: HttpXsrfInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: Response503Interceptor, multi: true },
];
